import { baseFilter } from '@packages/functions/lib/baseFilter';
import { baseTrim } from '@packages/functions/lib/baseTrim';
import type { AxiosError } from 'axios';

/**
 *
 * @param error
 * @param defaultMessage
 */
export function buildMessage(error: AxiosError | Error | string, defaultMessage = '') {
    if (!error) {
        return defaultMessage;
    }

    if (typeof error === 'string') {
        if (/^</.test(error.trim()) || /\/>/m.test(error)) {
            return buildMessage(defaultMessage || 'Something went wrong!');
        }

        error = `${error}`.trim();

        if (/[a-z0-9]$/i.test(error) && !/!$/i.test(error)) {
            error += '!';
        }

        return error;
    }

    const isAxios = !!error['isAxiosError'];

    if (isAxios) {
        return buildMessage(error['response'] || error.message, defaultMessage);
    }

    // noinspection SuspiciousTypeOfGuard
    if (error instanceof Error) {
        console.error(error);
        return buildMessage(error.message, defaultMessage);
    }

    if (error['data']) {
        return buildMessage(error['data'], defaultMessage);
    }

    if (error['error']) {
        return buildMessage(error['error'], defaultMessage);
    }

    if (error['message']) {
        return buildMessage(error['message'], defaultMessage);
    }

    if (error['messages']) {
        return buildMessage(error['messages'], defaultMessage);
    }

    if (error['title']) {
        return buildMessage(error['title'], defaultMessage);
    }

    if (typeof error === 'object') {
        if (Array.isArray(error)) {
            return (error as any[]).map((m) => buildMessage(m, defaultMessage)).join(' ');
        }

        return buildMessage(buildSingleErrorMessage(error), defaultMessage);
    }

    return defaultMessage;
}

/**
 *
 * @param errorMessage
 * @param message
 */
export function buildSingleErrorMessage(errorMessage: string | string[], message = ''): string {
    if (!message) {
        message = '';
    }

    if (message[message.length - 1] !== ' ') {
        message += ' ';
    }

    if (typeof errorMessage === 'string') {
        message += errorMessage;
        // message += t(errorMessage);
    } else if (Array.isArray(errorMessage)) {
        message += errorMessage
            .map((m) => buildSingleErrorMessage(m))
            .map(baseTrim)
            .filter(baseFilter)
            .join(', ');
    } else if (typeof errorMessage === 'object') {
        message += buildSingleErrorMessage(Object.keys(errorMessage).map((key) => errorMessage[key]));
    }

    return message;
}
